import { ContentCard, Tabs } from '@indigo-ag/component-module';
import i18next from 'i18next';
import React, { useState } from 'react';

import { DecisionSheetDebt, Lawsuit } from '@indigo-ag/schema';
import { DebtsContent } from './DebtsContent';
import { LawsuitsContent } from './LawsuitsContent';

enum TabId {
  DEBTS = 'DEBTS',
  LAWSUITS = 'LAWSUITS'
}

interface Props {
  debts?: DecisionSheetDebt[];
  debtsCount?: number | null;
  debtsTotalValue?: number | null;
  lawsuits?: Lawsuit[];
  lawsuitsCount?: number | null;
  lawsuitsTotalValue?: number | null;
}

export const ConsultationsCard = ({
  debts,
  debtsCount,
  debtsTotalValue,
  lawsuits,
  lawsuitsCount,
  lawsuitsTotalValue
}: Props) => {
  const [selectedTab, setSelectedTab] = useState(TabId.DEBTS);

  return (
    <ContentCard titleText={i18next.t('consultationsCard_title')}>
      <Tabs
        activeTabId={selectedTab}
        ariaLabel={i18next.t('consultationsCard_title')}
        items={[
          {
            id: TabId.DEBTS,
            title: i18next.t('consultationsCard_boaVista')
          },
          { id: TabId.LAWSUITS, title: i18next.t('consultationsCard_courtOfJustice') }
        ]}
        onChange={setSelectedTab}
        renderPanel={tabId => {
          switch (tabId) {
            case TabId.DEBTS:
              return <DebtsContent debts={debts} debtsCount={debtsCount} debtsTotal={debtsTotalValue} />;
            case TabId.LAWSUITS:
              return (
                <LawsuitsContent lawsuits={lawsuits} lawsuitsCount={lawsuitsCount} lawsuitsTotal={lawsuitsTotalValue} />
              );
            default:
              return null;
          }
        }}
      />
    </ContentCard>
  );
};
